import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import { Button } from "primereact/button";
import { usePermissions } from "./PermissionContext";

// Renders the page only if the current role may open this route.
export default function PermissionGate({ children }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { loading, canOpen, hasAny, firstAllowedPath, roleName } = usePermissions();

  if (loading) {
    return (
      <div className="flex justify-center items-center py-24">
        <ProgressSpinner style={{ width: 40, height: 40 }} />
      </div>
    );
  }

  if (canOpen(pathname)) return children;

  // Landing page (after login) not allowed → go to the first page this role can open
  const fallback = firstAllowedPath();
  if (pathname === "/dashboard" && fallback && fallback !== pathname) {
    return <Navigate to={fallback} replace />;
  }

  return (
    <div className="flex flex-col items-center justify-center text-center py-24 px-4">
      <i className="pi pi-lock" style={{ fontSize: "2.5rem", color: "#9ca3af" }} />
      <h2 className="text-xl font-semibold mt-4 mb-1">Access denied</h2>
      <p className="text-gray-500 m-0 max-w-md">
        {hasAny
          ? `Your role${roleName ? ` (${roleName})` : ""} doesn't have permission to open this page.`
          : "Your account has no permissions yet. Ask a Super Admin to assign you a role."}
      </p>
      {fallback && fallback !== pathname && (
        <Button label="Go back" icon="pi pi-arrow-left" className="p-primary-btn mt-5" onClick={() => navigate(fallback)} />
      )}
    </div>
  );
}
